import {useState} from "react";
import {useNavigate} from "react-router-dom";
import {useFormik} from "formik";
import {login} from "../../services";
import {initialValues, validationSchema} from "../../utils/formsValidator/loginFormValidator";
import {pushToast} from "../../utils/pushToast";
import Loading from "../../components/Loading";
import Input from "../../components/Input";

export default function Login() {
    const navigate = useNavigate();
    const [isLoading, setIsLoading] = useState(false);

    const onSubmit = async (values) => {
        setIsLoading(true);
        try {
            const {isSuccess, data} = await login(values);
            if (isSuccess) {
                localStorage.setItem('authToken', data);
                sessionStorage.setItem('mobile', values.mobile);
                sessionStorage.setItem('otpStartTime', Date.now().toString());
                navigate('/check/otp-code');
            } else {
                pushToast("شماره موبایل نادرست است.", "error");
            }
        } catch (error) {
            console.log(error);
            pushToast("ارسال کد ورود امکان‌پذیر نبود.", "error");
        } finally {
            setIsLoading(false);
        }
    };

    const formik = useFormik({initialValues, onSubmit, validationSchema, validateOnChange: true});

    return (
        <div className="container-xxl">
            <div className="authentication-wrapper authentication-basic container-p-y">
                <div className="authentication-inner py-4">
                    <div className="card">
                        <div className="card-body">
                            <div className="app-brand justify-content-center">
                                <img src="/logo.png" className="w-100" alt="Logo"/>
                            </div>
                            <h4 className="mb-2">شماره موبایل خود را وارد نمایید.</h4>
                            <form className={`needs-validation mb-3 ${!formik.isValid ? "was-validated" : ""}`}
                                  noValidate onSubmit={formik.handleSubmit} autoComplete="off">
                                <div className="mb-4 position-relative">
                                    <Input type="text" inputMode="tel" className="text-start" dir="ltr"
                                           name="mobile" placeholder="شماره موبایل خود را وارد کنید"
                                           autoComplete="off" label="شماره موبایل" formik={formik}/>
                                </div>
                                <button className="btn btn-primary d-grid w-100" type="submit" disabled={isLoading}>
                                    ارسال کد ورود {isLoading && <Loading/>}
                                </button>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}
